import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HotPage from "../pages/hot/page";
import PostPage from "../pages/post/page";
import SubmitPage from "../pages/submit/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hot",
    element: <HotPage />,
  },
  {
    path: "/post/:id",
    element: <PostPage />,
  },
  {
    path: "/submit",
    element: <SubmitPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;